<template>
  <view
    class="chat-audio-top"
    v-bind:class="{
      'height-large': audioObj.isShowRecordPanel,
      'height-small': audioObj.hasClick && !audioObj.isShowRecordPanel,
    }"
  >
    <view
      class="audio-container"
      v-bind:class="{
        'audio-container-show': audioObj.isShowRecordPanel,
        'audio-container-hidden':
          audioObj.hasClick && !audioObj.isShowRecordPanel,
      }"
    >
      <view class="audio-text-container">
        <u-subsection
          :list="list"
          :current="current"
          mode="subsection"
          active-color="#2f7cf6"
          @change="sectionChange"
        ></u-subsection>
        <view class="audio-text" v-html="audioObj.audioToTextResult"> </view>
        <view class="audio-text-container-mask"> </view>
      </view>
      <view class="audio-image-container" v-if="audioObj.isShowRecordPanel">
        <soundWave
          v-show="audioObj.isRecording"
          style="width: 150px; margin: 0 auto"
          ref="soundWave"
          @started="recordStarted"
          @process="recordProcess"
          @speechEnd="speechEnd"
          @stoped="recordStoped"
          @end="recordEnd"
        ></soundWave>
      </view>
      <view class="audio-function-container">
        <md-button class="audio-text" @click="recordPageCancel">取消</md-button>
        <view class="audio-image-wrap">
          <md-button
            :disabled="buttonDisabled"
            v-show="!audioObj.isRecording"
            @click="startRecord"
          >
            <image
              src="../../../assets/eln/icon_huatong.png"
              class="funcition-icon"
            >
            </image>
          </md-button>
          <md-button
            :disabled="buttonDisabled"
            v-show="audioObj.isRecording"
            @click="stopRecord"
          >
            <image
              src="../../../assets/eln/icon_huatong2.png"
              class="funcition-icon"
            >
            </image>
          </md-button>
        </view>
        <md-button class="audio-text" @click="recordPageSubmit">确定</md-button>
      </view>
      <view class="audio-bottom-text">
        {{ audioObj.isRecording ? "点击暂停" : "点击开始" }}
      </view>
    </view>
  </view>
</template>

<script>
import CryptoJS from "../../../util/crypto-js.mini.js";
import { hex_md5 } from "../../../util/md5.js";
import soundWave from "./soundWave.vue";
import { API_SIMPLE_FILE_UPLOAD } from "@/api/api.js";

export default {
  components: {
    soundWave,
  },
  props: {},
  data() {
    return {
      websocketInstance: null,
      recorder: null,
      list: [
        {
          name: "提问",
        },
        {
          name: "记录",
        },
      ],
      current: 0,

      audioObj: {
        APPID: window._CONFIG.XUNFEI_AUDIO.APPID,
        API_KEY: window._CONFIG.XUNFEI_AUDIO.API_KEY,
        API_SECRET: window._CONFIG.XUNFEI_AUDIO.API_SECRET,

        hasClick: false,
        isShowRecordPanel: false,
        isRecording: false,

        audio: null,
        audioToTextTempResult: "",
        audioToTextResult: "",
        statusText: "",
      },
      waitForRecordingEnd: false,

      rec: null, //播放器
      buttonDisabled: false,
    };
  },
  computed: {
    audioContainerStyle() {
      if (this.audioObj.isShowRecordPanel) {
        return {
          bottom: "0px",
        };
      } else {
        return {
          bottom: "-550px",
        };
      }
    },
  },

  methods: {
    gotoRecord() {
      this.audioObj.isRecording = false;
      this.audioObj.audio = null;
      this.audioObj.audioToTextTempResult = "";
      this.audioObj.audioToTextResult = "";

      this.audioObj.hasClick = true;
      this.audioObj.isShowRecordPanel = true;
    },
    async startRecord() {
      this.noMultipleClick();
      this.waitForRecordingEnd = false;
      await this.connectWebSocket();
      this.$refs.soundWave.recStart(() => {
        this.audioObj.isRecording = false;
        this.websocketInstance.close();
      });
    },
    async stopRecord() {
      this.noMultipleClick();
      this.websocketInstance.close();
      this.$refs.soundWave && this.$refs.soundWave.recStop();
      this.audioObj.isRecording = false;
    },
    recordPageCancel() {
      this.audioObj.isShowRecordPanel = false;
      this.stopRecord();
      this.audioObj.audioToTextResult = "";
      this.audioObj.audioToTextTempResult = "";
    },

    recordPageSubmit() {
      let self = this;

      if (this.audioObj.isRecording) {
        this.waitForRecordingEnd = true;
        this.stopRecord();
      } else {
        if (!self.audioObj.audio || !self.audioObj.audioToTextResult) {
          return;
        }
        this.doUploadFile();
        this.audioObj.isShowRecordPanel = false;
      }
    },
    sectionChange(index) {
      this.current = index;
    },
    noMultipleClick() {
      this.buttonDisabled = true;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        this.buttonDisabled = false;
      }, 2000);
    },

    doUploadFile() {
      let self = this;
      if (!self.audioObj.audio || !self.audioObj.audioToTextResult) {
        return;
      }
      console.log("doUploadFile----2222222", self.audioObj);
      /* uni.uploadFile({
				url: window._CONFIG.ajaxBaseUrl + API_SIMPLE_FILE_UPLOAD,
				name: "file",
				file: self.audioObj.audio.blob,
				header: self.header,
				formData: {},
				success: (res) => {
					if (res.statusCode == 200 && JSON.parse(res.data).code == 0) {
						let obj = JSON.parse(res.data).data;
						obj.mediaTimes = self.audioObj.audio.duration;
						obj.fileName = obj.name;
						obj.filePath = obj.path;

						self.audioEndConfirm(obj);
					} else {
						self.$message.error("请求错误" + res.statusCode);
					}
				},
				fail: (err) => {
					console.error(err);
				},
			}); */
    },
    audioEndConfirm(fileMD5) {
      console.log("audioEndConfirm-------------");
      let params = {
        infoType: "audio",
        msgType: this.current === 0 ? "ask" : "record",
        content: this.audioObj.audioToTextResult,
        attachmentList: [fileMD5],
      };
      this.$emit("audioEndConfirm", params);
    },

    /**
     * 获取websocket url
     * 该接口需要后端提供，这里为了方便前端处理
     */
    getWebSocketUrl() {
      // 请求地址根据语种不同变化
      var url = "wss://iat-api.xfyun.cn/v2/iat";
      var host = "iat-api.xfyun.cn";
      var apiKey = this.audioObj.API_KEY;
      var apiSecret = this.audioObj.API_SECRET;
      var date = new Date().toGMTString();
      var algorithm = "hmac-sha256";
      var headers = "host date request-line";
      var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;
      var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
      var signature = CryptoJS.enc.Base64.stringify(signatureSha);
      var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
      var authorization = btoa(authorizationOrigin);
      url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
      return url;
    },
    toBase64(buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    bufferToBase64(buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },

    async connectWebSocket() {
      let self = this;
      const websocketUrl = this.getWebSocketUrl();
      if ("WebSocket" in window) {
        this.websocketInstance = new WebSocket(websocketUrl);
      } else if ("MozWebSocket" in window) {
        this.websocketInstance = new MozWebSocket(websocketUrl);
      } else {
        alert("浏览器不支持WebSocket");
        return;
      }

      const recorder = new RecorderManager("xunfei/");

      this.recorder = recorder;
      recorder.onStart = (e) => {
        console.log("recorder:onStart", e);
        this.audioObj.isRecording = true;
      };

      this.websocketInstance.onopen = (e) => {
        self.audioObj.isRecording = true;
        self.sendStartMessage();
      };
      this.websocketInstance.onmessage = (e) => {
        self.renderResult(e.data);
      };
      this.websocketInstance.onerror = (e) => {
        console.log("websocketInstance.onerror:", e);
        self.$refs.soundWave.recStop();
        self.audioObj.isRecording = false;
      };
      this.websocketInstance.onclose = (e) => {
        console.log("websocketInstance.onclose:", e);

        self.audioObj.isRecording = false;
      };
    },
    sendStartMessage() {
      let self = this;
      self.audioObj.isRecording = true;
      self.audioObj.startTime = new Date().getTime();
      const params = {
        common: {
          app_id: this.audioObj.APPID,
        },
        business: {
          language: "zh_cn",
          domain: "iat",
          accent: "mandarin",
          vad_eos: 2000,
          dwa: "wpgs",
        },
        data: {
          status: 0,
          format: "audio/L16;rate=16000",
          encoding: "raw",
        },
      };
      this.websocketInstance.send(JSON.stringify(params));
    },
    renderResult(resultData) {
      let self = this;
      let jsonData = JSON.parse(resultData);

      if (jsonData.data && jsonData.data.result) {
        let data = jsonData.data.result;
        let str = "";
        let ws = data.ws;
        for (let i = 0; i < ws.length; i++) {
          str = str + ws[i].cw[0].w;
        }

        if (data.pgs) {
          if (data.pgs === "apd") {
            self.audioObj.audioToTextResult =
              self.audioObj.audioToTextTempResult;
          }
          self.audioObj.audioToTextTempResult =
            self.audioObj.audioToTextResult + str;
        } else {
          self.audioObj.audioToTextResult += str;
        }
      }

      if (jsonData.code === 0 && jsonData.data.status === 2) {
        // 识别最后一个结果
      }
      if (jsonData.code !== 0) {
        // 失败
        console.log("出错了:", jsonData);
      }
    },
    recordStarted() {
      console.log("Recording started");
    },

    recordProcess(chunk, powerLevel, duration, sampleRate) {
      if (
        this.websocketInstance &&
        this.websocketInstance.readyState === this.websocketInstance.OPEN &&
        this.audioObj.isRecording
      ) {
        this.websocketInstance.send(
          JSON.stringify({
            data: {
              status: 1,
              format: "audio/L16;rate=16000",
              encoding: "raw",
              audio: this.bufferToBase64(chunk.buffer),
            },
          })
        );
      }

      if (Date.now() - this.audioObj.startTime > 30000) {
        this.speechEnd();
      }
    },
    speechEnd() {
      if (
        this.websocketInstance &&
        this.websocketInstance.readyState === this.websocketInstance.OPEN &&
        this.audioObj.isRecording
      ) {
        this.websocketInstance.send(
          JSON.stringify({
            data: {
              status: 2,
              format: "audio/L16;rate=16000",
              encoding: "raw",
              audio: "",
            },
          })
        );
        this.audioObj.recordStatus = "STOP";
      }
    },
    recordStoped(audio) {
      this.audioObj.audio = audio;
      console.log("recordStoped*****************", audio);
      if (this.waitForRecordingEnd) {
        this.audioEndConfirm();
        this.audioObj.isShowRecordPanel = false;
      }
    },

    recordEnd() {
      console.log("Recording ended due to no sound detected.");
      this.doClose();
    },
  },
};
</script>

<style lang="less" scoped>
.chat-audio-top {
  .funcition-icon {
    display: inline-block;
    width: 30px;
    height: 30px;
    line-height: 24px;
  }
}

.audio-container {
  position: absolute;
  bottom: -340px;
  left: 0;
  right: 0;
  width: 100%;
  height: 340px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 12px 16px;
  z-index: 1;

  .audio-text-container {
    width: 100%;
    height: 60px;
    position: relative;

    .audio-text {
      width: 100%;
      height: 100%;
      font-size: 14rpx;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      overflow: hidden;
    }

    .audio-text-container-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 8px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      filter: blur(4px);
    }
  }

  .audio-image-container {
    height: 98px !important;
    overflow: hidden;
  }

  .audio-function-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;

    .audio-text {
      text-align: center;
      white-space: nowrap;
    }

    .audio-image-wrap {
      margin: 0 62px;

      .funcition-icon {
        width: 80px;
        height: 80px;
      }
    }

    ::v-deep uni-button {
      border: none;
      background-color: transparent;
    }

    ::v-deep uni-button:after {
      border: none;
      background-color: transparent;
    }
  }

  .audio-bottom-text {
    height: 22px;
    font-size: 14rpx;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    text-align: center;
    margin-bottom: 12px;
  }
}

.audio-container-show {
  bottom: 0;
  animation-name: mushow;
  animation-duration: 0.8s;
}

.audio-container-hidden {
  bottom: -340px;
  animation-name: myhidden;
  animation-duration: 1s;
}

@keyframes mushow {
  from {
    bottom: -340px;
  }

  to {
    bottom: 0;
  }
}

@keyframes myhidden {
  from {
    bottom: 0;
  }

  to {
    bottom: -340px;
  }
}

.height-large {
  height: 340px;
}

.height-small {
  height: 50px;
}
</style>
